import React from 'react';
import { useQuery } from 'react-query';
import { useLocation, useParams } from 'react-router-dom';

import { getTerm } from '@/api/public';
import LoadingSpinner from '@/components/Common/LoadingSpinner';
import MenuHeader from '@/components/Header/MenuHeader';
import CommonError from '@/pages/Error/CommonError';
import NotFoundPage from '@/pages/Error/NotFoundPage';
import DealerAgreementDocument from '@/pages/More/DealerAgreementDocument';

const typeList = {
  USE_TERMS: '서비스 이용약관',
  PERSONAL_INFO_TERMS: '개인정보 처리방침',
  MARKETING: '마케팅 정보 수신 동의 약관',
};

const TermsDetail = ({ dealer }: { dealer: boolean }) => {
  const { type } = useParams<{ type?: string }>();
  const { state } = useLocation();

  const isDealerAgreementPage = type === 'DEALER_AGREEMENT' && dealer;

  if (type && !(type in typeList) && !isDealerAgreementPage) {
    return <NotFoundPage />;
  }

  const getTerms = async () => {
    const termsType = type;
    try {
      const response = await getTerm();
      const res: Terms[] = response.data;
      const contentsData = res.find((data) => {
        const isSameType = data.termsType.code === termsType;
        if (!isSameType) return false;
        if (!dealer) return true;
        return data.membersType?.code === 'DEALER';
      })?.contents;
      return contentsData;
    } catch (error) {
      throw new Error('Error');
    }
  };

  const {
    data: termsData,
    isError,
    isLoading,
  } = useQuery(['get-terms', type], getTerms, {
    enabled: !state?.contents && type !== 'DEALER_AGREEMENT',
  });

  if (isDealerAgreementPage) {
    return (
      <>
        <MenuHeader title="딜러 약정서"></MenuHeader>
        <div className="w-full p-4 pt-[60px] pb-[20px]">
          <DealerAgreementDocument />
        </div>
      </>
    );
  }

  if (isError)
    return (
      <>
        <CommonError></CommonError>
      </>
    );

  const contents = state?.contents || termsData;

  const title = typeList[type as keyof typeof typeList] || 'Unknown Title';

  return (
    <>
      <MenuHeader title={title}></MenuHeader>
      {isLoading && <LoadingSpinner text={'로딩중입니다.'}></LoadingSpinner>}
      <div className="w-full p-4 pt-[60px] pb-[20px]">
        <div dangerouslySetInnerHTML={{ __html: contents }}></div>
      </div>
    </>
  );
};

export default TermsDetail;
